var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOutIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sign Out Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 923"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7722 22.9811L26.3346 17.6578C26.5524 17.4092 26.6639 17.0955 26.6641 16.7801C26.6642 16.5642 26.6122 16.3476 26.5065 16.1507C26.4595 16.0629 26.4022 15.9795 26.3346 15.9023L21.7722 10.579C21.293 10.0198 20.4513 9.95505 19.8921 10.4342C19.333 10.9134 19.2682 11.7552 19.7474 12.3143L22.432 15.4466L12.1058 15.4466C11.3694 15.4466 10.7724 16.0436 10.7724 16.78C10.7724 17.5163 11.3694 18.1133 12.1058 18.1133L22.4321 18.1133L19.7474 21.2458C19.2682 21.8049 19.333 22.6467 19.8921 23.1259C20.4513 23.6051 21.293 23.5403 21.7722 22.9811ZM13.3307 8.77995C14.0671 8.77995 14.6641 9.3769 14.6641 10.1133L14.6641 12.1133C14.6641 12.8497 15.261 13.4466 15.9974 13.4466C16.7338 13.4466 17.3307 12.8497 17.3307 12.1133L17.3307 10.1133C17.3307 7.90414 15.5399 6.11328 13.3307 6.11328L9.33073 6.11328C7.12159 6.11328 5.33073 7.90414 5.33073 10.1133L5.33073 23.4466C5.33073 25.6558 7.12159 27.4466 9.33073 27.4466L13.3307 27.4466C15.5399 27.4466 17.3307 25.6558 17.3307 23.4466L17.3307 21.4466C17.3307 20.7102 16.7338 20.1133 15.9974 20.1133C15.261 20.1133 14.6641 20.7102 14.6641 21.4466L14.6641 23.4466C14.6641 24.183 14.0671 24.7799 13.3307 24.7799L9.33073 24.7799C8.59435 24.7799 7.99739 24.183 7.99739 23.4466L7.99739 10.1133C7.99739 9.3769 8.59435 8.77995 9.33073 8.77995L13.3307 8.77995Z",
    fill: "#737791"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOutIcon);
export default __webpack_public_path__ + "static/media/sign-out-icon.90988f22e68d48c7b4e139d21b1ee7ca.svg";
export { ForwardRef as ReactComponent };